import sample_1 from './twinstarProtectUltra.jpg';

export const twinstarProtectUltra = {
    sample_1,
};
